<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row">
        <div class="col s3">
            <label [innerHTML]="'generic.components.locationPicker.nameInputPlaceholder' | translate"></label>
        </div>
        <div class="col s2">
            <label [innerHTML]="'generic.components.locationPicker.liftInputPlaceholder' | translate"></label>
        </div>
        <div class="col s2">
            <label [innerHTML]="'generic.components.locationPicker.shelfInputPlaceholder'| translate"></label>
        </div>
        <div class="col s3">
            <label [innerHTML]="'generic.components.locationPicker.positionInputPlaceholder'| translate"></label>
        </div>
        <div class="col s2">
            <label [innerHTML]="'generic.components.locationPicker.cartInputPlaceholder'| translate"></label>
        </div>
    </div>
    <div *ngFor="let storage of toolStorages; let i = index" class="form-row">
        <app-tool-location-picker
            (locationChange)="onLocationChange($event)"
            [toolStorage]="storage"
            [toolPosition]=""
            [formControlName]="storage.key"
            [formControl]="form.controls[storage.key]"
            [showErrors]="showValidations"
            [setIndex]="i+1"
            [toolName]="toolName">
        </app-tool-location-picker>
    </div>
</form>
